// app/signup/SignUp.jsx
'use client'

import SignUpComponent from '../../../component/SignUpComponent'
import { useTranslation } from 'react-i18next'

export default function SignUp() {
  const { t } = useTranslation()

  return (
    <div
      className="min-h-screen"
      style={{
        // backgroundImage: !safeCountry ? `url(/assets/signup.webp)` : null,
        backgroundPosition: 'top',
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat',
        backgroundColor: '#000',
      }}
    >
      {/* No side padding on phones: SignUpComponent's section and card pad
          40px a side already, and with 24 more here a 320px phone left the
          sign-in buttons 192px wide, wrapping "Continue with Google". */}
      <div className="mx-auto max-w-7xl sm:px-6 lg:px-8">
        <div className="mx-auto max-w-xl text-center my-6">
          <h1
            className="text-4xl font-semibold text-center py-2 flex items-center justify-center"
            style={{
              backgroundImage: 'linear-gradient(to right, #E3E0FF, #7E78DB)',
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent',
              backgroundClip: 'text',
              color: 'transparent',
            }}
          >
            {t('signUp')}
          </h1>
          <h2
            className="text-lg tracking-tight text-white"
            style={{ textShadow: '2px 2px 20px rgba(0, 0, 0, 1)' }}
          >
            {t('joinOver')}
          </h2>
        </div>

        <SignUpComponent />
      </div>
    </div>
  )
}
